import { optionsObjectToArray } from "@/common/utils/optionsObjectToArray";

export const reportFileTypes = {
  csv: 'CSV',
  xlsx: 'Excel (XLSX)',
  pdf: 'PDF'
};

export const reportFileTypesOptions = optionsObjectToArray(reportFileTypes);
